// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"47d6ac68","244":"86c63682","492":"154a7ad4","579":"a0bc9183","853":"ea05ddfb"}[chunkId] + ".chunk.js";
};